var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarsIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.286,
    height: 29.281,
    viewBox: "0 0 29.286 29.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M-2249.08-9357.433a14.655,14.655,0,0,1-14.13-10.853,14.543,14.543,0,0,1,1.461-11.107,14.532,14.532,0,0,1,8.887-6.818,14.661,14.661,0,0,1,3.8-.5,14.652,14.652,0,0,1,14.128,10.852,14.542,14.542,0,0,1-1.462,11.106,14.549,14.549,0,0,1-8.888,6.821A14.753,14.753,0,0,1-2249.08-9357.433Zm-.434-21.751a.62.62,0,0,0-.563.354l-1.7,3.509a.625.625,0,0,1-.469.346l-3.854.59a.621.621,0,0,0-.5.428.623.623,0,0,0,.161.642l2.813,2.7a.631.631,0,0,1,.184.554l-.629,3.848a.611.611,0,0,0,.138.5.625.625,0,0,0,.476.223.619.619,0,0,0,.3-.073l3.438-1.84a.623.623,0,0,1,.295-.075.626.626,0,0,1,.287.07l3.464,1.788a.618.618,0,0,0,.286.07.641.641,0,0,0,.485-.229.608.608,0,0,0,.133-.508l-.688-3.838a.617.617,0,0,1,.174-.554l2.773-2.745a.62.62,0,0,0,.152-.643.619.619,0,0,0-.508-.42l-3.862-.532a.631.631,0,0,1-.476-.34l-1.75-3.481A.616.616,0,0,0-2249.514-9379.184Z",
    transform: "translate(2263.716 9386.714)",
    fill: "#2c5cde"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsIc);
export default __webpack_public_path__ + "static/media/stars-ic.5c83fcdfa17b7112fc83a36b745bef39.svg";
export { ForwardRef as ReactComponent };